import useForm from '@common/hooks/useForm';
import { removeAllToasts, ToastWithKeyType } from '@common/store/toasts/slice';
import { validateRequired } from '@common/utils/validations';
import Button from '@lib/Button';
import FormInput from '@lib/FormInput';
import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';

import { RootState } from '@/store';

const validate = (values: Record<string, string>) => {
  const errors = {
    email: validateRequired(values.email),
    password: validateRequired(values.password),
  };
  return errors;
};

interface LoginFormProps {
  isModal?: boolean;
  onSubmitHandler: (
    values: Record<string, unknown>,
    setDynamicErrors: (errors: Record<string, unknown>) => void,
    afterLogin: () => void,
  ) => Promise<void>;
  afterLogin?: () => void;
  toasts: ToastWithKeyType[];
  removeAllToasts: typeof removeAllToasts;
}

const LoginForm: React.FC<LoginFormProps> = ({ onSubmitHandler, afterLogin, isModal, removeAllToasts }) => {
  const {
    values,
    touched,
    errors,
    submissions,
    submitting,
    handleChange,
    handleSubmit,
    handleBlur,
    asyncErrors,
    setDynamicErrors,
  } = useForm({
    validate,
    isModal,
  });
  return (
    <form
      onSubmit={handleSubmit(async (values: Record<string, unknown>) => {
        removeAllToasts();
        await onSubmitHandler(values, setDynamicErrors, afterLogin);
      })}
    >
      <FormInput
        name="email"
        className="mt-32"
        label="Email ID"
        type="text"
        value={values.email || ''}
        onChange={handleChange}
        onBlur={handleBlur}
        error={(submissions || touched.email) && (errors.email || asyncErrors.email)}
      />
      <FormInput
        name="password"
        className="mt-16"
        label="Password"
        type="password"
        enableVisbilityToggle={isModal}
        value={values.password || ''}
        onChange={handleChange}
        onBlur={handleBlur}
        error={(submissions || touched.password) && (errors.password || asyncErrors.password)}
      />
      <Button
        type="submit"
        disabled={submitting}
        className={classnames(
          'font-medium mt-24 w-full text-14 text-white w-220 flex justify-center items-center rounded-md',
          {
            'bg-theme h-40': !isModal,
            'bg-auth-button h-46': isModal,
          },
        )}
        font-customisation="para-text"
        button-customisation="page-button"
      >
        Login
      </Button>
    </form>
  );
};

export default connect(
  ({ toasts }: RootState) => ({
    toasts,
    removeAllToasts,
  }),
  { removeAllToasts },
)(LoginForm);
